import { render, staticRenderFns } from "./deliveryagentmaster.vue?vue&type=template&id=7cdcff66&scoped=true&"
import script from "./deliveryagentmaster.vue?vue&type=script&lang=js&"
export * from "./deliveryagentmaster.vue?vue&type=script&lang=js&"
import style0 from "./deliveryagentmaster.vue?vue&type=style&index=0&id=7cdcff66&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cdcff66",
  null
  
)

export default component.exports